export const ActionTypes = {
  LOADING: "UPDATE_OPTION_CRITERIA_LOADING",
  ERROR: "UPDATE_OPTION_CRITERIA_ERROR",
  SUCCESS: "UPDATE_OPTION_CRITERIA_SUCCESS",
  SET_LOADING: "SET_LOADING",
};
